import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { FormattedServiceTemplateDetails, ServiceTemplateDetails } from "@idw-types/data/service-template-details/service-template-details";

export const formatServiceTemplateDetails = (serviceTemplateDetails: ServiceTemplateDetails, axnCompanies: Array<AxnCompany>): FormattedServiceTemplateDetails => {
    return {
        ...serviceTemplateDetails,
        organization: axnCompanies.find(axnCompany => axnCompany.id === serviceTemplateDetails.organizationID) || null
    };
}

export const unFormatServiceTemplateDetails = (serviceTemplate: FormattedServiceTemplateDetails): ServiceTemplateDetails => {
    const { id, description, name, organization, status, relyingPartyID, ssoTemplate } = serviceTemplate;
    return {
        id, description, name, status,
        organizationID: organization?.id || null,
        relyingPartyID,
        ssoTemplate
    };
};